<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item">Administración</li>
  <li class="breadcrumb-item active">Tipos de Preguntas</li>
</ol>

<h1 class="page-header"><i class="fas fa-list-check"></i> Tipos de Preguntas<small> Catálogo de tipos de respuesta</small></h1>

<div class="scrollable">
  <panel [noButton]="true">
    <div class="d-flex justify-content-between align-items-center mb-3">
      <span class="fs-5 fw-600">Catálogo de tipos</span>
      <button class="btn btn-sm btn-primary" (click)="open(modalType)"><i class="fas fa-plus me-1"></i>Nuevo tipo</button>
    </div>
    <table class="table table-striped table-hover">
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Tipo de dato</th>
          <th>Regex de validación</th>
          <th class="text-center">Estado</th>
          <th class="text-center col-1"><i class="fas fa-cogs"></i></th>
        </tr>
      </thead>
      <tbody>
        @for(type of types; track type.id){
        <tr>
          <td class="fw-500">{{type.label}}</td>
          <td><span class="badge bg-info">{{type.dataType}}</span></td>
          <td><code>{{type.regex || '—'}}</code></td>
          <td class="text-center">
            <button class="btn btn-xs btn-ghost" (click)="toggle(type)" triggers="hover" [ngbTooltip]="type.enabled ? 'Deshabilitar' : 'Habilitar'">
              <i class="fas" [class.fa-toggle-on]="type.enabled" [class.fa-toggle-off]="!type.enabled"></i>
            </button>
          </td>
          <td class="text-center text-nowrap">
            <button class="btn btn-xs btn-ghost" (click)="open(modalType, type)" triggers="hover" ngbTooltip="Editar">
              <i class="fas fa-edit"></i>
            </button>
            <button class="btn btn-xs btn-ghost" (click)="confirmRemove(type)" triggers="hover" ngbTooltip="Eliminar">
              <i class="fas fa-trash"></i>
            </button>
          </td>
        </tr>
        }@empty {
        <tr><td colspan="5" class="text-center text-muted">No hay tipos de pregunta registrados</td></tr>
        }
      </tbody>
    </table>
  </panel>
</div>

<ng-template #modalType let-d="dismiss">
  <div class="modal-header">
    <span class="fs-3 fw-700">{{ typeForm.value.id ? 'Editar' : 'Nuevo' }} tipo de pregunta</span>
  </div>
  <div class="modal-body" [formGroup]="typeForm">
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Nombre</label>
      <div class="col-md-7">
        <input type="text" class="form-control" formControlName="label" placeholder="Ej: Si/No, Archivo, Fecha, Números, Comentarios" />
      </div>
    </div>
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Tipo de dato</label>
      <div class="col-md-7">
        <select class="form-select" formControlName="dataType">
          @for(o of dataTypeOptions; track o.value){
          <option [value]="o.value">{{o.label}}</option>
          }
        </select>
        <span class="text-muted small d-block mt-1">Define el input que verá el usuario al llenar la evaluación.</span>
      </div>
    </div>
    <div class="row mb-3">
      <label class="form-label col-form-label col-md-3">Regex de validación</label>
      <div class="col-md-7">
        <input type="text" class="form-control" formControlName="regex" placeholder="Ej: ^[0-9]+$" />
        <span class="text-muted small d-block mt-1">Opcional. Valida los caracteres permitidos en inputs numéricos y de texto.</span>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-md-7 offset-md-3">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="typeEnabled" formControlName="enabled">
          <label class="form-check-label" for="typeEnabled">Activo</label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-danger" (click)="d('Cross click')">Cerrar</button>
    <button class="btn btn-primary" (click)="save()">Guardar</button>
  </div>
</ng-template>
